import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-db23e9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textWithHighlightComponent" }
const _hoisted_2 = ["textContent"]

import { computed, ComputedRef } from 'vue';

import { TextWithHighlight } from '@/data/datatypes/TextWithHighlight';

interface Props {
  text: string;
  highlightRegex?: RegExp;
  textWithHighlights?: TextWithHighlight[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TextWithHighlightedTerm',
  props: {
    text: {},
    highlightRegex: {},
    textWithHighlights: {}
  },
  setup(__props: any) {

const props = __props;

const splitText: ComputedRef<string[]> = computed(() => {
  if (props.textWithHighlights) {
    const result: string[] = [];
    for (const textWithHighlight of props.textWithHighlights) {
      if (textWithHighlight.pre) {
        result.push(textWithHighlight.pre);
      }
      if (textWithHighlight.highlight) {
        result.push(textWithHighlight.highlight);
      }
      if (textWithHighlight.post) {
        result.push(textWithHighlight.post);
      }
    }
    return result;
  } else if (props.text && props.highlightRegex) {
    const result: string[] = [];
    let remainder = props.text;
    while (remainder.length) {
      const match = props.highlightRegex.exec(remainder);
      if (!match) {
        result.push(remainder);
        remainder = '';
      } else {
        result.push(remainder.substr(0, match.index));
        result.push(match[0]);
        remainder = remainder.substr(match.index + match[0].length);
      }
    }
    return result;
  } else {
    return [props.text];
  }
});

function isHighlightTerm(text: string | undefined): boolean {
  if (text) {
    if (props.textWithHighlights) {
      for (const textWithHighlight of props.textWithHighlights) {
        if (textWithHighlight.highlight === text) {
          return true;
        }
      }
    } else if (props.highlightRegex) {
      return !!props.highlightRegex?.test(text);
    }
  }
  return false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitText.value, (block, name, index) => {
      return (_openBlock(), _createElementBlock("span", {
        textContent: _toDisplayString(block),
        key: index,
        class: _normalizeClass(isHighlightTerm(block) ? 'highlight' : '')
      }, null, 10, _hoisted_2))
    }), 128))
  ]))
}
}

})